import { Injectable } from '@angular/core';

declare const Flowbite: any;

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor() { }

  showSuccess(message: string, title: string = 'Éxito'): void {
    this.showToast(message, title, 'success');
  }

  showError(message: string, title: string = 'Error'): void {
    this.showToast(message, title, 'error');
  }

  showWarning(message: string, title: string = 'Advertencia', showAcceptButton: boolean = false): void {
    this.showToast(message, title, 'warning', showAcceptButton);
  }

  showInfo(message: string, title: string = 'Información'): void {
    this.showToast(message, title, 'info');
  }

  private showToast(message: string, title: string, type: 'success' | 'error' | 'warning' | 'info', showAcceptButton: boolean = false): void {
    // Crear el elemento del toast
    const toastElement = document.createElement('div');
    toastElement.id = `toast-${Date.now()}`;
    toastElement.className = `fixed top-4 right-4 z-50 max-w-sm w-full bg-white border border-gray-200 rounded-lg shadow-lg transform transition-all duration-300 ease-in-out translate-x-full`;
    
    // Determinar colores según el tipo
    let iconClass = '';
    let titleColor = '';
    let borderColor = '';
    
    switch (type) {
      case 'success':
        iconClass = 'fas fa-check-circle text-green-500';
        titleColor = 'text-green-800';
        borderColor = 'border-green-200';
        break;
      case 'error':
        iconClass = 'fas fa-exclamation-circle text-red-500';
        titleColor = 'text-red-800';
        borderColor = 'border-red-200';
        break;
      case 'warning':
        iconClass = 'fas fa-exclamation-triangle text-yellow-500';
        titleColor = 'text-yellow-800';
        borderColor = 'border-yellow-200';
        break;
      case 'info':
        iconClass = 'fas fa-info-circle text-blue-500';
        titleColor = 'text-blue-800';
        borderColor = 'border-blue-200';
        break;
    }

    const acceptButton = showAcceptButton ? `
      <div class="px-4 pb-4">
        <button type="button" class="w-full bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors" onclick="this.closest('.fixed').remove()">
          Aceptar
        </button>
      </div>
    ` : '';

    toastElement.innerHTML = `
      <div class="flex items-center p-4 ${borderColor}">
        <div class="flex-shrink-0">
          <i class="${iconClass} text-xl"></i>
        </div>
        <div class="ml-3 flex-1">
          <p class="text-sm font-medium ${titleColor}">${title}</p>
          <p class="text-sm text-gray-600 mt-1">${message}</p>
        </div>
        <div class="ml-4 flex-shrink-0">
          <button type="button" class="inline-flex text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition ease-in-out duration-150" onclick="this.closest('.fixed').remove()">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      ${acceptButton}
    `;

    // Agregar al DOM
    document.body.appendChild(toastElement);

    // Animar entrada
    setTimeout(() => {
      toastElement.classList.remove('translate-x-full');
    }, 100);

    // Auto-remover después de 5 segundos
    setTimeout(() => {
      if (toastElement.parentNode) {
        toastElement.classList.add('translate-x-full');
        setTimeout(() => {
          if (toastElement.parentNode) {
            toastElement.remove();
          }
        }, 300);
      }
    }, 5000);
  }
}
